import React from "react";
import CommonLayout from "../../components/Layouts/CommonLayout";
import AllPhotos from "../../components/UserFlow/FolderView/AllPhotos";

const AllPhotosPage = () => {
  return <AllPhotos />;
};

export default AllPhotosPage;
